import { Component, OnInit, Input } from '@angular/core';
import { BusinessUser } from 'src/app/models/business-user.model';
import { IUserAgent } from 'src/app/models/user-agent.model';

@Component({
  selector: 'app-call-main',
  templateUrl: './call-main.component.html',
  styleUrls: [
    './call-main.component.scss',
    './../../../../assets/scss/call-screen.scss'
  ]
})
export class CallMainComponent implements OnInit {
  @Input() user: BusinessUser;
  @Input() description: string;
  @Input() userAgent: string;
  @Input() createdAt: string;
  @Input() media: string;

  constructor() { }

  ngOnInit(): void {
  }

  get userAgentNormalized(): IUserAgent {
    try {
      return JSON.parse(this.userAgent);
    } catch (error) {
      this.userAgent = undefined;
    }
  }
}
